// src/pages/AddSupplier.js

import React, { useEffect, useState, useContext } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import {
  Typography,
  Paper,
  Button,
  Grid,
  Box,
  CircularProgress,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { addSupplier } from '../services/supplierService';
import { getInventoryItems } from '../services/inventoryService';
import supplierSchema from '../models/supplierSchema';
import DynamicForm from '../components/DynamicForm';
import { OrgContext } from '../contexts/OrgContext';
import BackButton from '../components/BackButton';

const AddSupplier = () => {
  const { orgId } = useContext(OrgContext);
  const methods = useForm();

  const navigate = useNavigate();

  const [inventoryOptions, setInventoryOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Fetch inventory items for product selection
    getInventoryItems().then((data) => {
      setInventoryOptions(data);
    });
  }, []);

  const onSubmit = (data) => {
    setLoading(true);
    // Ensure lead_time is an integer
    const processedData = {
      ...data,
      lead_time: parseInt(data.lead_time, 10),
      products_supplied: data.products_supplied || [],
    };

    addSupplier(orgId, processedData)
      .then(() => navigate(`/${orgId}/suppliers`))
      .catch((error) => {
        console.error('Error adding supplier:', error);
        // Handle error
      })
      .finally(() => setLoading(false));
  };

  return (
    <Paper
      sx={{
        p: 3,
        maxWidth: 900,
        mx: 'auto',
        backgroundColor: '#1e1e1e',
        color: 'text.primary',
      }}
    >
      <BackButton />
      <Typography variant="h5" gutterBottom>
        Add Supplier
      </Typography>
      <FormProvider {...methods}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <form onSubmit={methods.handleSubmit(onSubmit)} autoComplete="off">
            <DynamicForm
              schema={supplierSchema}
              control={methods.control}
              errors={methods.formState.errors}
              inventoryOptions={inventoryOptions}
            />
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={12} textAlign="right">
                <Button type="submit" variant="contained" color="primary">
                  Add Supplier
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </FormProvider>
    </Paper>
  );
};

export default AddSupplier;
